import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Sidebar from "../../components/Sidebar/Sidebar";
import Header from "../../components/Header/Header";

import dashboardRoutes from "../../routes/routes/routes";
import Footer from "../../components/Footer/Footer";

import _ from "lodash";
import image from "../../assets/img/macizo.jpg";
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
let dimensions = getWindowDimensions();
console.log("Bienvenido a la Consola DEV BI TRANSFLESA");
class SchedulingLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: image,
      color: "black",
      hasImage: true,
      fixedClasses: "dropdown show-dropdown open",
      sidebarShow: dimensions.width > 990 ? true : false,
    };
    this.outputEvent = this.outputEvent.bind(this);
  }
  handleImageClick = (image) => {
    this.setState({ image: image });
  };
  handleColorClick = (color) => {
    this.setState({ color: color });
  };
  handleHasImage = (hasImage) => {
    this.setState({ hasImage: hasImage });
  };
  handleFixedClick = () => {
    if (this.state.fixedClasses === "dropdown") {
      this.setState({ fixedClasses: "dropdown show-dropdown open" });
    } else {
      this.setState({ fixedClasses: "dropdown" });
    }
  };
  componentWillMount() {
    let token = localStorage.getItem("token");
    if (token === null) {
      this.props.history.push("/");
    }
  }

  outputEvent(event) {
    const { sidebarShow } = this.state;
    // the event context comes from the Child
    this.setState({ sidebarShow: !sidebarShow });
  }

  render() {
    const adminLinks = (
      <Switch>
        {dashboardRoutes.map((prop, key) => {
          if (prop.redirect)
            return <Redirect from={prop.path} to={prop.to} key={key} />;
          return (
            <Route
              path={
                _.isEmpty(prop.path) || prop.path === null
                  ? dashboardRoutes[1].path
                  : prop.path
              }
              component={_.isEmpty(prop.path) ? () => {} : prop.component}
              key={key}
            />
          );
        })}
      </Switch>
    );
    // this.props.location.pathname !== "/Organigrama"
    return (
      <div className="wrapper">
        <div>
          {/* 	{this.state.sidebarShow !== false ?
                        <div>
                            <Sidebar {...this.props} image={this.state.image}
                                color={this.state.color}
                                hasImage={this.state.hasImage} />
                            <div id="main-panel" className="main-panel" ref="mainPanel">
                                <Header {...this.props} clickHandler={this.outputEvent} {...this.state} />
                                {adminLinks
                                }
                                <Footer />
                            </div>
                        </div>
                        :
                        <div>

                            <div>
                                <Header {...this.props} clickHandler={this.outputEvent} {...this.state} />
                                {adminLinks
                                }
                                <Footer />
                            </div>
                        </div>
                    } */}

          <div>
            {this.state.sidebarShow !== true ? (
              <Sidebar
                {...this.props}
                image={this.state.image}
                color={this.state.color}
                hasImage={this.state.hasImage}
              />
            ) : (
              ""
            )}
            <div
              id={
                this.state.sidebarShow !== true
                  ? "main-panel"
                  : "main-panel-all"
              }
              className={
                this.state.sidebarShow !== true
                  ? "main-panel"
                  : "main-panel-all"
              }
              ref={this.state.sidebarShow !== true ? "mainPanel" : ""}
            >
              <Header
                {...this.props}
                clickHandler={this.outputEvent}
                {...this.state}
              />
              {adminLinks}
              <Footer />
            </div>
          </div>
          {/* <div>
						<Sidebar
							{...this.props}
							image={this.state.image}
							color={this.state.color}
							hasImage={this.state.hasImage}
						/>
						<div id="main-panel" className="main-panel" ref="mainPanel">
							<Header {...this.props} clickHandler={this.outputEvent} {...this.state} />
							{adminLinks}
							<Footer />
						</div>
					</div> */}
        </div>
      </div>
    );
  }
}

SchedulingLayout.propTypes = {};

SchedulingLayout.contextTypes = {};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {})(SchedulingLayout);
